import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class LoginSSOData {
    company: string;
}
export abstract class LoginSSOInterface {
    authentincateSSO: (data: object, data2: string) => Observable<any>;
}